import axios, { AxiosInstance } from 'axios';
import ApiUrl from './config';

export class BracketPrintClient {
  private http: AxiosInstance;

  constructor(baseUrl: string = ApiUrl, instance?: AxiosInstance) {
    this.http = instance ?? axios.create({ baseURL: baseUrl });
  }

  async printOlympicProtocol(bracketId: number): Promise<void> {
    const response = await this.http.get('/api/Bracket/PrintOlympicProtocol', {
      params: { id: bracketId },
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  }

  async printMixedProtocol(bracketId: number): Promise<void> {
    const response = await this.http.get('/api/Bracket/PrintMixedProtocol', {
      params: { id: bracketId },
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  }
}

export const bracketPrintClient = new BracketPrintClient();
